<template>
  <div id="app" class="app-layout">
    <AppHeader
      v-model="searchQuery"
      @reset-view="resetView"
    />

    <main class="container main-content">
      <router-view
        :search-query="searchQuery"
        @reset-search="searchQuery = ''"
      />
    </main>

    <footer class="app-footer">
      <div class="container footer-content">
        <p>🥞 <strong>Receptbanken</strong></p>
      </div>
    </footer>
  </div>
</template>

<script>
import AppHeader from './components/AppHeader.vue'

export default {
  name: 'App',
  components: {
    AppHeader
  },
  data() {
    return {
      searchQuery: ''
    }
  },
  watch: {
    searchQuery(newVal) {
      // Om användaren börjar söka från en enskild receptsida, ta dem tillbaka till listan för att se sökresultat
      if (newVal.trim() && this.$route.path.startsWith('/recept/')) {
        this.$router.push('/')
      }
    },
    // Nollställ sökfältet när man klickar in på ett recept
    '$route.path'(newPath) {
      if (newPath.startsWith('/recept/')) {
        this.searchQuery = ''
      }
    }
  },
  methods: {
    resetView() {
      this.searchQuery = ''
      if (this.$route.path !== '/') {
        this.$router.push('/')
      }
    }
  }
}
</script>

<style scoped>
.app-layout {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.main-content {
  flex-grow: 1;
}

.app-footer {
  margin-top: auto;
  border-top: 1px solid var(--color-border);
  background-color: var(--color-card-bg);
  padding: 24px 0 calc(24px + env(safe-area-inset-bottom, 0px));
  text-align: center;
  font-size: 0.9rem;
  color: var(--color-text-muted);
}

@media (max-width: 640px) {
  .app-footer {
    padding: 18px 0 calc(18px + env(safe-area-inset-bottom, 0px));
    font-size: 0.82rem;
  }
}
</style>
